import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { OracaoProvider } from 'src/app/services/oracao/oracao';


@Component({
  selector: 'app-oracao-testemunho',
  templateUrl: './oracao-testemunho.page.html',
  styleUrls: ['./oracao-testemunho.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    NomenclaturaPipe
  ],
})
export class OracaoTestemunhoPage implements OnInit {
  isTestemunho: boolean = false;
  id: any;
  oracao: any = {};
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public oracaoProvider: OracaoProvider,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public modalCtrl: ModalController,
  ) {
    this.isTestemunho = this.navParams.get('isTestemunho');
    this.id = this.navParams.get('id');
    this.oracaoProvider.getOracao(this.id).subscribe((data) => {
      this.oracao = data;
    });

  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
